import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment, UrlMatchResult } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DashboardComponent } from './layouts/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ChangePasswordComponent } from './modules/user-management/change-password/change-password/change-password.component';
import { UpdateUserProfileComponent } from './modules/user-management/user-profile-update/update-user-profile/update-user-profile.component';
import { InformationLinksComponent } from './modules/settings/information-links/information-links.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AnonymousDialogSigninComponent } from './modules/respond-pages/anonymous-dialog-signin/anonymous-dialog-signin.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized/unauthorized.component';
import { CreatePinComponent } from './modules/respond-pages/create-pin/create-pin.component';
import { GlobalConstants } from './shared/services/constants/globalconstants';
import { AuthCallbackResolver } from '@modules/auth/pages/callback/auth-callback.resolver';

const routes: Routes = [
  {
    matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
      const queryParams = new URLSearchParams(window.location.search);
      const isRootPath = segments.length === 0;
      if (isRootPath && queryParams.has('code')) {
        return { consumed: segments };
      }
      return null;
    },
    pathMatch: 'full',
    resolve: { callback: AuthCallbackResolver },
    component: DashboardComponent
  },
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            m => m.DashboardModule
          )
      },
      {
        path: 'incidentreport',
        loadChildren: () =>
          import('./modules/IncidentReport/incident-report.module').then(
            m => m.IncidentReportModule
          )
      },
      {
        path: 'incidentreportfile',
        loadChildren: () =>
          import('./modules/IncidentReportFile/incident-report-file.module').then(
            m => m.IncidentReportFileModule
          )
      },
      {
        path: 'actionitems',
        loadChildren: () =>
          import('./modules/action-items/action-items.module').then(
            m => m.ActionItemsModule
          )
      },
      {
        path: 'dialog',
        loadChildren: () =>
          import('./modules/dialog/dialog.module').then(
            m => m.DialogModule
          )
      },
      {
        path: 'inbox',
        loadChildren: () =>
          import('./modules/inbox/inbox.module').then(
            m => m.InboxModule
          )
      },
      {
        path: 'location',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./modules/locations/locations.module').then(
            m => m.LocationsModule
          )
      },
      {
        path: 'division',
        loadChildren: () =>
          import('./modules/divisions/divisions.module').then(
            m => m.DivisionsModule
          )
      },
      {
        path: 'incidentTypes',
        loadChildren: () =>
          import('./modules/incident-types/incident-types.module').then(
            m => m.IncidentTypesModule
          )
      },
      {
        path: 'dbas',
        loadChildren: () =>
          import('./modules/companydbas/companydbas.module').then(
            m => m.CompanydbasModule
          )
      },
      {
        path: 'settingslist',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            m => m.SettingsModule
          )
      },
      {
        path: 'emailtmpls',
        loadChildren: () =>
          import('./modules/email-templates/email-templates.module').then(
            m => m.EmailTemplatesModule
          )
      },
      {
        path: 'userlist',
        loadChildren: () =>
          import('./modules/usersystem/usersystem.module').then(
            m => m.UsersystemModule
          )
      },
      {
        path: 'usermanagement',
        loadChildren: () =>
          import('./modules/user-management/usermanagement.module').then(
            m => m.UserManagementModule
          )
      },
      {
        path: `${GlobalConstants.InformationLinksRoute}`,
        component: InformationLinksComponent
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./modules/analytics/analytics.module').then(
            m => m.AnalyticsModule
          )
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/respond-pages/respond-page.module').then(
            m => m.RespondPageModule
          )
      }
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'respond',
    component: AnonymousDialogSigninComponent
  },
  {
    path: 'createpin',
    component: CreatePinComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
